import RevenueCenters from './RevenueCenters'

export default RevenueCenters
